// extracted by mini-css-extract-plugin
module.exports = {"taskDetailsCell":"style-module_taskDetailsCell__NL2D0USrozNjVLD57C2p","blockIcon":"style-module_blockIcon__S5TolIXIwJ655i424aoI","cell":"style-module_cell__Bw9O2MLdGTJwnFuT4HqR"};